import { instance, errorService, savePreviousData } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import Vue from 'vue'
import { socketEvents, formatKeys } from '@/services/config'
import { showNotification } from '@/services/calculate'
import DynamicTable from '@/components/DynamicComponents/Projects/Grid'

export default {
  components: {
    DynamicTable,
  },
  props: [
    'child',
    'projectData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'screen_Name',
    'projectModule',
    'type',
    'columnSettings',
    'componentProjectKey',
  ],
  data() {
    return {
      dropdownInfo: this.dropdownData,
      savePreviousData: savePreviousData,
      columnDefs: [],
      loader: false,
      openCreate: false,
      create: new Vue(),
      componentKey: this.componentProjectKey,
      buildingData: this.projectData,
      form: {
        id: undefined,
        constructionQualityFactor: undefined,
        constructionQualityFactorId: undefined,
        constructionQualityFactorValue: undefined,
        conditionFactor: undefined,
        conditionFactorId: undefined,
        conditionFactorValue: undefined,
        takeoff: [],
        screenName: 'Building Shell',
      },
      loading: false,
      isArchive: false,
    }
  },
  beforeMount() {
    this.isArchive = _.get(this.projectData, 'isArchive', false)
    this.loadingConfig()
  },
  created() {
    this.child.$off('addNewRecord')
    this.child.$on('addNewRecord', this.addNewRecord)
  },
  mounted() {
    this.$socketHub.$on('message-received', this.recievedMessage)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
    this.$root.$off('onUpdateTakeoff')
    this.$root.$off('onCloneTakeoff')
    this.$root.$off('onDeleteTakeoff')
    this.getBuildingShell()
  },
  beforeDestroy() {
    this.child.$off('addNewRecord')
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          field: 'checkbox',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isLocked',
          headerTooltip: 'Locked',
          width: 30,
          editable: false,
          cellRenderer: 'lockRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            isArchive: this.isArchive,
          },
          floatingFilter: false,
          resizable: false,
          suppressSizeToFit: true,
          hide: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          width: 5,
          hide: true,
          floatingFilter: false,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellStyle: { textAlign: 'left' },
          width: 100,
          cellEditor: 'selectEditor',
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          resizable: true,
          cellRendererParams: {
            type: 'dynamicTable',
            dropdownName: 'contract',
            dropdownData: this.dropdownInfo,
          },
          editable: !this.isArchive,
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dropdownName: 'category',
            dropdownData: this.dropdownInfo,
          },
          width: 150,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Category Code',
          suppressSizeToFit: true,
          resizable: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center', backColor: 'red' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'autocomplete',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            name: 'takeoff_Name',
            screen: this.projectModule ? 'Project' : 'Template',
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Takeoff',
          resizable: true,
          width: 420,
          editable: !this.isArchive,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'calculation',
            dropdownData: this.dropdownInfo.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
          editable: !this.isArchive,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Quantity',
          resizable: true,
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellEditor: 'selectEditor',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'dynamicTable',
            dropdownName: 'unit',
            dropdownData: this.dropdownInfo,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Unit',
          resizable: true,
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          cellRendererParams: {
            type: 'dynamicTable',
            placeholder: 'Unit Cost',
            precision: 2,
            min: 0,
          },
          width: 120,
          headerTooltip: 'Unit Cost',
          resizable: true,
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            dropdownName: 'conditionFactor',
            dropdownData: this.dropdownData.condition_factor,
            name: 'conditionFactor',
            width: '350px !important',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Condition Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            precision: 3,
            name: 'multiplier',
          },
          width: 100,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
          editable: !this.isArchive,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            screenType: 'Project',
          },
          floatingFilter: false,
          width: 60,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
          menuTabs: [],
        },
      ]
    },

    getBuildingShell() {
      this.loader = true
      instance
        .get(
          projectAPIs.project.asset.buildingShell.details(
            this.$route.params.id,
            this.projectData.assetId,
          ),
        )
        .then(response => {
          this.form = formatKeys(_.get(response.data, 'result', null), this.form)
          Object.assign(this.buildingData, {
            area_Total_Building: _.get(response.data, 'result.areaTotalBuilding', 0),
            area_Building_Footprint: _.get(
              response.data,
              'result.areaBuildingFootprint',
              0,
            ),
            number_Of_Stories: _.get(response.data, 'result.numberOfStories', 0),
            perimeter_Building_Footprint: _.get(
              response.data,
              'result.perimeterBuildingFootprint',
              0,
            ),
            average_Story_Height: _.get(
              response.data,
              'result.averageStoryHeight',
              0,
            ),
            totalSiteArea: _.get(response.data, 'result.totalSiteArea', 0),
            numberOfBuilding: _.get(response.data, 'result.numberOfBuilding', 0),
          })
          this.getTakeoffs()
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    getTakeoffs() {
      this.loader = true
      instance
        .get(
          projectAPIs.project.asset.buildingShell.takeoff.list(
            this.$route.params.id,
            this.projectData.assetId,
            this.form.id,
          ),
        )
        .then(response => {
          this.form.takeoff = _.get(response.data, 'result', [])
          this.form.takeoff.forEach(element => {
            if (element.categoryCode) {
              element.categoryCode = Number(element.categoryCode)
            }
          })
          const isValid = this.form.takeoff.some(i => i.isLocked)
          if (isValid) {
            const index = this.columnDefs.findIndex(
              i => i.field === 'isLocked',
            )
            this.columnDefs[index].hide = false
          }
          this.loader = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    updateTakeOff(takeoff) {
      this.form.takeoff = [...takeoff]
    },

    addNewRecord() {
      this.create.$emit('addRecord')
    },

    updateColumnSettings(request) {
      this.$emit('updateColumnSettings', request)
    },

    recievedMessage(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.projectSidebarUpdated) {
        this.$root.$emit('projectSideBarUpdated', message)
      } else if (data.EventType === socketEvents.buildingShellUpdated) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.cloneProjectBuildingShell) {
        this.componentKey++
        this.$root.$emit('popupUpdation', false, true, null)
        this.getBuildingShell()
      } else if (data.EventType === socketEvents.error) {
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification('error', 'Socket', data.Result)
      }
    },
  },
}
